import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from "../../component/abstract-crud.component";
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { EspecialidadeService } from "../especialidade.service";

@Component({
  selector: "app-especialidade-list",
  templateUrl: "./especialidade-list.component.html",
  styleUrls: ["./especialidade-list.component.css"]
})
export class EspecialidadeListComponent extends AbstractCrudComponent implements OnInit {

  displayedColumns: string[] = ['nome', 'details'];

  constructor(private especialidadeService: EspecialidadeService,
    router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();
  
    super.ngOnInit();
  }

  reloadData() {
    this.especialidadeService.listar()
      .subscribe(data => {
        // console.log(data)
        this.data = data;
        this.configurarDataSource();
     }, error => {
        console.log(error);
      });
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.especialidadeService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterEspecialidade']);
  }

  details(id: number) {
    this.router.navigate(['manterEspecialidade'], {
      state: {
        id: id,
        isUpdate: 'N'
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterEspecialidade'], {
      state: {
        id: id,
        isUpdate: 'S'
      }
    });
  }
}
